var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgInteractive = function SvgInteractive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 45"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51 43.95l-5.79-6.42c-2.238-3.022 1.974-6.17 5.264-4.532l5.397 4.28V12.35s.526-3.4 4.08-3.4c3.554 0 3.554 3.778 3.554 3.778v16.367m0-4.262s.364-1.882 3.275-1.882 3.032 2.235 3.032 2.235v5.765m0-5.001s1.033-2 3.326-2c2.294 0 2.982 2.25 2.982 2.25v5.75m2.103-3.3s1.07-1.7 3.332-1.7c2.261 0 2.975 2.308 2.975 2.308v14.693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.528 13.95a9.25 9.25 0 00.743-3.642c0-5.168-4.236-9.357-9.461-9.357-5.226 0-9.462 4.19-9.462 9.357 0 1.118.198 2.19.562 3.184"
  }))));
};
export default SvgInteractive;